import { render, staticRenderFns } from "./VATReturn.vue?vue&type=template&id=365b237d&scoped=true&"
import script from "./VATReturn.vue?vue&type=script&lang=js&"
export * from "./VATReturn.vue?vue&type=script&lang=js&"
import style0 from "./VATReturn.vue?vue&type=style&index=0&id=365b237d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b237d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365b237d')) {
      api.createRecord('365b237d', component.options)
    } else {
      api.reload('365b237d', component.options)
    }
    module.hot.accept("./VATReturn.vue?vue&type=template&id=365b237d&scoped=true&", function () {
      api.rerender('365b237d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/accountingreport/VATReturn.vue"
export default component.exports